var render, staticRenderFns
import script from "./vBlockLink.vue?vue&type=script&lang=js"
export * from "./vBlockLink.vue?vue&type=script&lang=js"
import style0 from "./vBlockLink.vue?vue&type=style&index=0&id=47a46cd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports